var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-heart-plus-button",on:{"click":function($event){$event.preventDefault();return _vm.handleClick($event)}}},[_c('font-awesome-icon',{attrs:{"icon":_vm.prefixIcon}}),_c('font-awesome-icon',{attrs:{"icon":"heart"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }